import * as React from 'react';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint } from '../../enums';
import { MenuPositionData } from '../../interfaces';

import {
  Container,
  LogoWithSocials,
  MenuPositions,
  MenuPositionsColumn,
  StyledLogo,
  StyledMenuPosition,
  StyledSocialsLinks,
  TopBorderContainer
} from './footer.styled';
import { FooterProps } from './footer.types';

export const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  const { menuPositions, withTopBorder = false, socials, className }: FooterProps = props;
  const isMobile: boolean = useMediaQuery({ query: Breakpoint.Mobile });
  const middleIndex: number = Math.ceil(menuPositions.length / 2);
  const oneThirdIndex: number = Math.ceil(menuPositions.length / 3);
  const twoThirdsIndex: number = oneThirdIndex * 2 + ((menuPositions.length % 3 === 1) ? -1 : 0);

  return (
    <Container className={className}>
      <TopBorderContainer $withTopBorder={withTopBorder} />
      <LogoWithSocials>
        <StyledLogo />
        <StyledSocialsLinks items={socials} />
      </LogoWithSocials>
      <MenuPositions>
        {!isMobile ? (
          <>
            <MenuPositionsColumn>
              {menuPositions.slice(0, oneThirdIndex).map((menuPosition: MenuPositionData) => (
                <StyledMenuPosition {...menuPosition} key={menuPosition.label} />
              ))}
            </MenuPositionsColumn>
            <MenuPositionsColumn>
              {menuPositions.slice(oneThirdIndex, twoThirdsIndex).map((menuPosition: MenuPositionData) => (
                <StyledMenuPosition {...menuPosition} key={menuPosition.label} />
              ))}
            </MenuPositionsColumn>
            <MenuPositionsColumn>
              {menuPositions.slice(twoThirdsIndex).map((menuPosition: MenuPositionData) => (
                <StyledMenuPosition {...menuPosition} key={menuPosition.label} />
              ))}
            </MenuPositionsColumn>
          </>
        ) : (
          <>
            <MenuPositionsColumn>
              {menuPositions.slice(0, middleIndex).map((menuPosition: MenuPositionData) => (
                <StyledMenuPosition {...menuPosition} key={menuPosition.label} />
              ))}
            </MenuPositionsColumn>
            <MenuPositionsColumn>
              {menuPositions.slice(middleIndex).map((menuPosition: MenuPositionData) => (
                <StyledMenuPosition {...menuPosition} key={menuPosition.label} />
              ))}
            </MenuPositionsColumn>
          </>
        )}
      </MenuPositions>
    </Container>
  );
};
